import { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { candidatePortalApi } from '../../api/candidatePortal';
import { useCandidateAuth } from './CandidateAuthContext';
import { CareersNav } from './CareersNav';

export function CareersSignupPage() {
  const { refresh } = useCandidateAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const nextPath = searchParams.get('next') || '/careers/my-applications';
  const [error, setError] = useState<string | null>(null);
  const { register, handleSubmit, formState: { isSubmitting } } = useForm<{ fullName: string; email: string; phone?: string; password: string }>();

  const onSubmit = async (values: { fullName: string; email: string; phone?: string; password: string }) => {
    setError(null);
    try {
      await candidatePortalApi.signup(values);
      await refresh();
      navigate(nextPath);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to create account.');
    }
  };

  return (
    <div className="careers-page">
      <CareersNav />
      <div className="card" style={{ maxWidth: 420, margin: '24px auto' }}>
        <h1>Create Your Candidate Account</h1>
        <p className="muted">Save your profile once, apply to multiple positions, and track your application status.</p>
        {error && <p className="field-error">{error}</p>}
        <form onSubmit={handleSubmit(onSubmit)}>
          <label>Full Name<input {...register('fullName', { required: true })} /></label>
          <label>Email<input type="email" {...register('email', { required: true })} /></label>
          <label>Phone<input {...register('phone')} /></label>
          <label>Password (at least 8 characters)<input type="password" {...register('password', { required: true, minLength: 8 })} /></label>
          <div className="form-actions"><button type="submit" disabled={isSubmitting}>{isSubmitting ? 'Creating…' : 'Create Account'}</button></div>
        </form>
        <p className="muted">Already have an account? <Link to={`/careers/login${nextPath !== '/careers/my-applications' ? `?next=${encodeURIComponent(nextPath)}` : ''}`}>Sign in</Link></p>
      </div>
    </div>
  );
}
